<div class="space-y-4">
  <!-- Encabezado -->
  <div class="flex items-center justify-between gap-3 flex-wrap">
    <div class="flex items-center gap-2">
      <h3 class="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide">
        Historial de correos
      </h3>
      <!-- Indicador sutil de "actualizando…" (no bloquea la lista) -->
      @if (syncing) {
        <span class="inline-flex items-center gap-1.5 text-xs text-gray-400 dark:text-gray-500">
          <span class="animate-spin rounded-full h-3 w-3 border-b-2 border-brand-500"></span>
          Actualizando…
        </span>
      }
    </div>
    <button
      type="button"
      (click)="refrescar()"
      [disabled]="syncing"
      class="inline-flex items-center gap-1.5 rounded-lg border border-gray-300 px-2.5 py-1.5 text-xs font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
      <svg class="w-3.5 h-3.5" [class.animate-spin]="syncing" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
      </svg>
      Refrescar
    </button>
  </div>

  <!-- Hint sutil opcional: buzón no conectado -->
  @if (noInboxHint) {
    <div class="flex items-center gap-2 rounded-lg bg-blue-light-50 dark:bg-blue-light-500/15 px-3 py-2 text-xs text-blue-light-700 dark:text-blue-light-400">
      <svg class="w-3.5 h-3.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
      </svg>
      Conecta tu buzón para ver las respuestas recibidas.
    </div>
  }

  <!-- Loading -->
  @if (loading) {
    <div class="flex items-center justify-center gap-3 py-10">
      <div class="animate-spin rounded-full h-5 w-5 border-b-2 border-brand-500"></div>
      <span class="text-sm text-gray-500 dark:text-gray-400">Cargando historial...</span>
    </div>
  }

  <!-- Error -->
  @if (!loading && error) {
    <div class="rounded-lg bg-error-50 dark:bg-error-500/15 p-3 text-sm text-error-700 dark:text-error-400">
      {{ error }}
    </div>
  }

  <!-- Empty -->
  @if (!loading && !error && items.length === 0) {
    <div class="text-center py-10 text-gray-400 dark:text-gray-500">
      <svg class="w-10 h-10 mx-auto mb-3 opacity-50" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
          d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
      </svg>
      <p class="text-sm">Aún no hay correos con este contacto.</p>
    </div>
  }

  <!-- Timeline -->
  @if (!loading && !error && items.length > 0) {
    <div class="relative pl-1">
      <!-- Línea vertical -->
      <div class="absolute left-[15px] top-2 bottom-2 w-px bg-gray-200 dark:bg-gray-700"></div>
      <ul class="space-y-3">
        @for (item of items; track item.sourceType + '-' + item.sourceId) {
          <li class="relative">
            <!-- Dot de dirección -->
            <span
              class="absolute left-[8px] top-4 h-3.5 w-3.5 rounded-full ring-4 ring-white dark:ring-gray-900"
              [class]="isSent(item) ? 'bg-brand-500' : 'bg-success-500'"></span>

            <button
              type="button"
              (click)="abrirItem(item)"
              class="w-full text-left flex items-start gap-3 pl-8 pr-3 py-3 rounded-lg border border-gray-100 dark:border-gray-700/50 bg-gray-50 dark:bg-gray-800/50 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors">
              <div class="min-w-0 flex-1">
                <!-- Fila 1: dirección + estado/lectura + fecha -->
                <div class="flex items-center justify-between gap-2 flex-wrap">
                  <div class="flex items-center gap-2 flex-wrap">
                    <!-- Badge de dirección -->
                    @if (isSent(item)) {
                      <span class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-brand-50 text-brand-600 dark:bg-brand-500/15 dark:text-brand-400">
                        <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
                        </svg>
                        Enviado
                      </span>
                    } @else {
                      <span class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-success-50 text-success-700 dark:bg-success-500/15 dark:text-success-400">
                        <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
                        </svg>
                        Recibido
                      </span>
                    }

                    <!-- Estado (solo SENT) -->
                    @if (isSent(item) && item.status) {
                      <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium" [class]="statusColor(item.status)">
                        {{ statusLabel(item.status) }}
                      </span>
                    }

                    <!-- No leído (solo RECEIVED) -->
                    @if (isUnread(item)) {
                      <span class="inline-flex items-center gap-1 text-xs font-medium text-brand-600 dark:text-brand-400">
                        <span class="h-2 w-2 rounded-full bg-brand-500"></span>
                        No leído
                      </span>
                    }
                  </div>
                  <span class="text-xs text-gray-500 dark:text-gray-400 flex-shrink-0">{{ formatDate(item.occurredAt) }}</span>
                </div>

                <!-- Fila 2: asunto -->
                <p class="mt-1 text-sm text-gray-900 dark:text-white truncate"
                   [class.font-semibold]="isUnread(item)"
                   [class.font-medium]="!isUnread(item)">
                  {{ item.subject || '(Sin asunto)' }}
                </p>

                <!-- Fila 3: contraparte -->
                <p class="mt-0.5 text-xs text-gray-600 dark:text-gray-300 truncate">
                  {{ isSent(item) ? 'Para: ' : 'De: ' }}{{ item.counterpartName || item.counterpartEmail || '—' }}
                </p>
                @if (item.counterpartName && item.counterpartEmail) {
                  <p class="text-xs text-gray-400 dark:text-gray-500 truncate">{{ item.counterpartEmail }}</p>
                }

                <!-- Fila 4: snippet -->
                @if (item.snippet) {
                  <p class="mt-1 text-xs text-gray-500 dark:text-gray-400 line-clamp-2">{{ item.snippet }}</p>
                }
              </div>
            </button>
          </li>
        }
      </ul>
    </div>

    <!-- Paginación simple -->
    @if (globalTotalPages > 1) {
      <div class="flex items-center justify-between gap-2 pt-2">
        <span class="text-xs text-gray-500 dark:text-gray-400">
          {{ globalTotalElements }} correo(s) · Página {{ pageDisplay }} de {{ globalTotalPages }}
        </span>
        <div class="flex items-center gap-2">
          <button
            (click)="cambiarPagina(globalPage - 1)" [disabled]="!hasPrevious"
            class="inline-flex items-center rounded-lg border border-gray-300 px-2.5 py-1 text-xs font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
            Anterior
          </button>
          <button
            (click)="cambiarPagina(globalPage + 1)" [disabled]="!hasNext"
            class="inline-flex items-center rounded-lg border border-gray-300 px-2.5 py-1 text-xs font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
            Siguiente
          </button>
        </div>
      </div>
    }
  }
</div>

<!-- Modal de detalle del correo ENVIADO (GET /api/emails/{id}) -->
<app-correo-detail-modal
  [isOpen]="showDetailModal"
  [emailId]="selectedEmailId"
  (close)="cerrarModal()">
</app-correo-detail-modal>

<!-- Modal de detalle del correo RECIBIDO (GET /api/emails/inbox-message/{id}) -->
<app-correo-recibido-detail-modal
  [isOpen]="showReceivedModal"
  [inboxMessageId]="selectedInboxMessageId"
  (close)="cerrarReceived()">
</app-correo-recibido-detail-modal>
